export interface AudioChunk {
    seq: number;
    wav: Blob;
    startTime: number;
    endTime: number;
    sessionId: string;
}
export interface TranscriptEntry {
    seq: number;
    response: string;
    success: boolean;
    processingTime: string;
    wordCount?: number;
    durationSec: number;
    sessionId: string;
}

export type RecordingState = 'idle' | 'recording' | 'paused' | 'stopped';
export type ScribeState = RecordingState;
export type SpeechProvider = 'audio-chunks' | 'azure' | 'ASR';
export type SttUIStatus = 'listening' | 'processing' | '';
export type AudioSourceType = 'transcribe' | 'telehealth';

export interface AudioSourceOption {
  label: string;
  value: AudioSourceType;
  disabled?: boolean;
}

export function resolveOverlayStatus(
    provider: SpeechProvider,
    recording: boolean,
    status: SttUIStatus
): SttUIStatus {
    return provider === 'azure' ? (recording ? 'listening' : '') : status;
}